export default {
	firstName: "Nome",
	lastName: "Sobrenome",
	nickname: "Apelido",
	email: "Email",
	name: "Nome",
	birthDate: "Data de Nascimento",
	firstVisitDate: "Primeira Visita",
	gender: "Gênero",
	cpf: "CPF",
	rg: "RG",
	maritalStatus: "Estado Civil",
	type: "Tipo",
	phone: "Telefone",
	mobile: "Celular",
	whatsappOptIn: "Aceita receber avisos por WhatsApp",
	whatsappOptInHint: "A pessoa autoriza receber cobranças e avisos do templo por WhatsApp, enviados pelo número oficial do ORI (consentimento LGPD)",
	address: "Endereço",
	street: "Logradouro",
	addressNumber: "Número",
	addressComplement: "Complemento",
	neighborhood: "Bairro",
	city: "Cidade",
	state: "Estado (UF)",
	zipCode: "CEP",
	zipCodeNotFound: "CEP não encontrado",
	zipCodeLookupFailed: "Não foi possível consultar o CEP agora — preencha o endereço à mão",
	paiDeCabeca: "Pai de Cabeça",
	maeDeCabeca: "Mãe de Cabeça",
	fatherName: "Nome do Pai",
	motherName: "Nome da Mãe",
	nationality: "Nacionalidade",
	occupation: "Profissão",
	emergencyContactName: "Contato de Emergência",
	emergencyContactPhone: "Telefone de Emergência",
	bloodType: "Tipo Sanguíneo",
	healthNotes: "Saúde e Medicação",
	healthNotesHint:
		"Problemas de saúde, alergias e medicação de uso contínuo. Dado sensível pela LGPD — só dirigentes veem e editam.",
	healthAdminOnly: "Somente dirigentes veem os dados de saúde",
	imageUseConsent: "Autoriza uso de imagem",
	imageUseConsentHint:
		"A pessoa autoriza o templo a usar sua imagem em fotos e vídeos (consentimento LGPD)",
	imageUseConsentSince: "Autorizado em {date}",
	notes: "Observações",
	sections: {
		personal: "Dados",
		address: "Endereço",
		family: "Família",
		emergency: "Contato de emergência",
		health: "Saúde",
		consents: "Autorizações",
		permissions: "Permissões",
		spiritual: "Espiritual",
	},
	fullRegistration: "Cadastro completo",
	tabs: {
		basic: "Informações",
		functions: "Funções",
		guides: "Guias",
		journey: "Jornada",
	},
	roleHistory: {
		loadError: "Erro ao carregar histórico da jornada",
	},
	types: {
		medium: "Médium",
		assistencia: "Assistência",
	},
	// Chaves iguais aos valores do enum do Prisma — o rótulo sai de
	// `people.genders[person.gender]` sem tabela de conversão no meio.
	genders: {
		MALE: "Masculino",
		FEMALE: "Feminino",
		OTHER: "Outro",
	},
	maritalStatuses: {
		SINGLE: "Solteiro(a)",
		MARRIED: "Casado(a)",
		STABLE_UNION: "União estável",
		DIVORCED: "Divorciado(a)",
		WIDOWED: "Viúvo(a)",
	},
	photo: {
		upload: "Atualizar Foto",
		uploadSuccess: "Foto atualizada com sucesso",
		uploadError: "Erro ao atualizar foto",
		tabFile: "Arquivo",
		tabWebcam: "Webcam",
		capture: "Capturar",
		retake: "Tirar Outra",
		dragHere: "Arraste uma imagem ou clique para selecionar",
		maxSize: "Tamanho máximo: {size}MB",
		webcamError: "Não foi possível acessar a câmera",
		addPhoto: "Toque para adicionar foto",
		closeCamera: "Fechar câmera",
	},
	edit: "Editar Pessoa",
	create: "Criar Pessoa",
	messages: {
		invalidForm: "Confira os campos destacados antes de salvar",
		loading: "Carregando pessoa...",
		loadError: "Erro ao carregar pessoa",
		created: "{name} foi criado(a) com sucesso",
		updated: "{name} foi atualizado(a) com sucesso",
		deleted: "{name} foi excluído(a) com sucesso",
		createError: "Erro ao criar pessoa",
		updateError: "Erro ao atualizar pessoa",
		deleteError: "Erro ao excluir pessoa",
	},
	consultants: {
		searchPlaceholder: "Buscar consulente...",
		filters: {
			all: "Todos",
			withTickets: "Com Fichas",
			withReturn: "Com Retorno",
			recent: "Recentes",
		},
		newConsultant: "Novo Consulente",
		table: {
			code: "Código",
			name: "Nome",
			lastVisit: "Última Visita",
			contact: "Contato",
			visits: "Atend.",
			birthday: "Aniversário",
			registration: "Cadastro",
			status: "Status",
		},
		neverAttended: "Nunca atendido",
		ticket: "ficha",
		tickets: "fichas",
		return: "Retorno",
		tooltips: {
			newTicket: "Nova Ficha",
			alreadyHasTicket: "Consulente já possui ficha ativa neste ritual",
			history: "Histórico",
			edit: "Editar",
		},
		empty: {
			title: "Nenhum consulente encontrado",
			description: "Tente ajustar os filtros ou cadastre um novo consulente",
		},
		stats: {
			total: "Total",
			withTickets: "Com Fichas",
			returns: "Retornos",
		},
	},
	mediums: {
		searchPlaceholder: "Buscar médium...",
		filters: {
			all: "Todos",
			journeyStage: "Estágio da Jornada",
			orixa: "Orixá",
			function: "Função",
		},
		newMedium: "Novo Médium",
		table: {
			code: "Código",
			name: "Nome",
			journey: "Jornada",
			orixas: "Orixás",
			function: "Função",
			contact: "Contato",
		},
		tooltips: {
			view: "Ver Perfil",
			edit: "Editar",
			journey: "Gerenciar Jornada",
		},
		empty: {
			title: "Nenhum médium encontrado",
			description: "Tente ajustar os filtros ou inclua um novo médium na corrente",
		},
		stats: {
			total: "Total",
			active: "Ativos",
		},
	},
	archive: {
		dialogTitle: "Arquivar Pessoa",
		archiveAction: "Arquivar",
		unarchiveAction: "Desarquivar",
		blockedByFinancialHistory: "Esta pessoa tem movimentações financeiras e não pode ser excluída — o histórico dela faz parte da prestação de contas. Arquive: ela sai das listas, as cobranças em aberto são canceladas e todo o rastro é preservado. Dá para desarquivar depois.",
		blockedByMandate: "Esta pessoa tem débito automático ATIVO. Cancele o débito automático antes, senão a cobrança continua acontecendo no provedor de pagamento mesmo com a ficha fora das listas.",
		reasonLabel: "Motivo do arquivamento (opcional)",
		reasonPlaceholder: "Ex.: mudou de cidade, afastou-se da casa",
		archived: "{name} foi arquivada.",
		unarchived: "{name} voltou para as listas.",
		error: "Não foi possível concluir o arquivamento.",
		banner: "Pessoa arquivada por {user} em {date}. Ela não aparece nas listas do dia a dia.",
		filterLabel: "Arquivadas",
	},
	deleteDialog: {
		title: "Excluir Pessoa Permanentemente",
		warning: "Esta ação é irreversível e excluirá permanentemente todos os dados relacionados a esta pessoa:",
		items: {
			journeyHistory: "Histórico de jornada e hierarquia",
			tickets: "Fichas de atendimento",
			messages: "Mensagens e observações",
			returns: "Retornos",
			guides: "Vínculos com guias",
			functions: "Funções atribuídas",
			financial: "Assinaturas e movimentações financeiras",
		},
		impactTitle: "O que esta pessoa tem hoje:",
		impact: {
			openCharges: "Cobranças em aberto",
			paidMovements: "Pagamentos registrados",
			subscriptions: "Assinaturas ativas",
			tickets: "Fichas de atendimento",
			messages: "Mensagens",
			nothing: "Nada registrado — a ficha pode ser excluída sem perda.",
		},
		codeInstruction: "Para confirmar, digite o código abaixo:",
		codePlaceholder: "Digite o código de confirmação",
		codeError: "Código incorreto",
		deleting: "Excluindo...",
	},
	mergeDialog: {
		menuLabel: "Duplicado",
		title: "Mesclar pessoa em outra",
		warning: "Esta ação é irreversível. Todos os vínculos de \"{name}\" (jornada, fichas, mensagens, retornos, guias, funções, financeiro) serão movidos para a pessoa selecionada e \"{name}\" será excluída.",
		description: "Selecione a pessoa que receberá todo o histórico:",
		destinationLabel: "Pessoa destino",
		destinationHint: "A pessoa que ficará com todos os vínculos da atual",
		sameAsSourceError: "A pessoa destino não pode ser a mesma da origem",
		codeInstruction: "Para confirmar, digite o código abaixo:",
		codePlaceholder: "Digite o código de confirmação",
		codeError: "Código incorreto",
		confirm: "Mesclar e remover",
		merging: "Mesclando...",
		successMessage: "{source} foi mesclada em {destination} com sucesso",
		errorMessage: "Erro ao mesclar pessoas",
	},
};
